import React, { useState } from "react";

const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  role: "user",
  userName: "",
  userData: {},
  login: (token) => {},
  logout: () => {},
});

export const AuthContextProvider = (props) => {
  const initialToken = sessionStorage.getItem("token");
  const initialRole = sessionStorage.getItem("role");
  const initialUserId = sessionStorage.getItem("id");
  const initialUserName = sessionStorage.getItem("username");

  const [token, setToken] = useState(initialToken);
  const [role, setRole] = useState(initialRole);
  const [userId, setUserId] = useState(initialUserId);
  const [userName, setUseName] = useState(initialUserName);

  const userIsLoggedIn = !!token;
  const userRole = role;
  const user_id = userId;
  const newUserName = userName;

  const loginHandler = (token, role, id, userName, userData) => {
    setToken(token);
    setRole(role);
    setUserId(id);
    setUseName(userName);

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("role", role);
    sessionStorage.setItem("id", id);
    sessionStorage.setItem("username", userName);
    sessionStorage.setItem("userdata", JSON.stringify(userData));
  };

  const logoutHandler = () => {
    window.location.assign("/");

    setToken(null);
    setRole(null);
    setUserId(null);
    setUseName(null);

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("id");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("userdata");
  };

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    role: userRole,
    user_id: user_id,
    userName: newUserName,

    login: loginHandler,
    logout: logoutHandler,
  };

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>;
};

export default AuthContext;
